<template>

    <div class="current_site"><img src="../assets/icons/sites_white.svg" /><span>{{unit.name}}</span></div>


</template>

<script>
    export default {
        
        data : function(){       
            return {
                
                message: '',

            };
        },
        computed:{
            unit()
            {
              return this.$store.getters.getUnit;
            },
            account()
            {
              return this.$store.getters.getAccount;
            }
        },
        watch :{

           


        },
        created : function(){
            this.$bus.$on('error_message', this.showErrorBox);
        },
        beforeDestroy() {
            this.$bus.$off('error_message', this.showErrorBox);
        },
        mounted : function ()
        {
        },
        destroyed () {
        },
        methods:{

            showErrorBox(message){
                this.$modal.show('alert-modal');
                this.message = message;
            },

            hideBox()
            {
                this.$modal.hide('alert-modal');
                setTimeout(()=>{ this.message = ''; }, 1000);
            }

        }
    }
</script>

<style lang="scss" scoped>
  .current_site{
    img,span{
      float:right;
      display:block;
      margin-left:10px;
    }
    img{
              width:1rem;

    }
    span{
      float:right;
      margin-top:-3px;
    }
    overflow: auto;



    position: absolute;
    right:30px;
    text-align: right;
    top:30px;




  }

</style>
